<template>
    <tr>
        <td>
            {{item.id}}
        </td>
        <td>
            <span v-if="edit">
                <b-form-input
                    type="text"
                    v-model="form.name"
                    placeholder="Nombre del grupo de actividad"
                    class="border"
                    style=""
                >
                </b-form-input>
            </span>
            <span v-else>
                {{item.name}}
            </span>
        </td>
        <td>
            <span v-if="edit">
                <v-select
                    :options="geopointsListAdmin"
                    :reduce="(option) => option.id"
                    
                    label="name"
                    v-model="form.geo_point_target_id"
                    style=""
                    class="border"
                >
                </v-select>
            </span>
            <span v-else>
                {{item.geo_point_target != null ? item.geo_point_target.name : '-'}}
            </span>
        </td>
        <td>
            <span v-if="edit">
                <b-form-input
                    type="time"
                    v-model="form.begin_hour"
                    placeholder="Hora de inicio"
                    class="border"
                    style=""
                >
                </b-form-input>
            </span>
            <span v-else>
                {{item.begin_hour}}
            </span>
        </td>
        <td>
            <span v-if="edit">
                <v-select
                    :options="manage_options"
                    :reduce="(option) => option.value"
                    label="label"
                    v-model="form.manage"
                    style=""
                    class="border"
                >
                </v-select>
            </span>
            <span v-else>
                <i v-if="item.manage" class="fa fa-check-circle mr-2 text-success" aria-hidden="true" title="Sí"></i>
                <i v-else class="fa fa-times-circle mr-2 text-danger" aria-hidden="true" title="No"></i>
            </span>
        </td>
        <td>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="editRow"
                v-if="!edit"
            >
                <i class="text-center fa fa-wrench fa-fw"></i>
                Editar
            </b-button>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="saveChanges"
                v-if="edit"
            >
                <i class="text-center fa fa-save fa-fw"></i>
                Guardar
            </b-button>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="showDeleteConfirmation"
            >
                <i class="text-center fa fa-trash fa-fw"></i>
                Eliminar
            </b-button>
            <admin-activity-group-confirm-delete-modal :activity_group="item" :suprazone="suprazone" />

            <b-button 
                @click="copyStops" 
                variant="light" 
                class="border"
            >
                <i class="text-center fa fa-copy fa-fw"></i>
                Duplicar
            </b-button>

        </td>
    </tr>
</template>

<script>
/* eslint-disable */
import AdminActivityGroupConfirmDeleteModal from './AdminActivityGroupConfirmDeleteModal'
import { mapGetters } from 'vuex'

export default {
    components: {
        AdminActivityGroupConfirmDeleteModal,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        suprazone: {
            type: Object,
            required: false,
        }
    },
    data() {
        return {
            edit: false,
            form: {
                name: this.item != null ? this.item.name : '',
                geo_point_target_id: this.item != null ? this.item.geo_point_target.id : null,
                begin_hour: this.item != null ? this.item.begin_hour: '',
                manage: this.time != null ? this.item.manage: true,
            },
            manage_options: [
                {
                    label: 'Sí',
                    value: true,
                },
                {
                    label: 'No',
                    value: false,
                }
            ],
        }
    },
    async mounted() {
        
    },
    methods: {
        async editRow()  {
            this.edit = true
            const data = {
                'suprazone_id': this.suprazone.id,
            }
            await this.$store.dispatch("geopoints/getAllGeopointsBySuprazone", data)
        },
        async saveChanges() {
            this.edit = false
            const data = {
                suprazone_id: this.suprazone.id,
                activity_group_id: this.item.id,
                payload: {
                    ...this.form
                }
            }
            await this.$store.dispatch('groups/updateActivityGroup', data)
            this.$notify({
                group: "foo",
                title: "Grupo de actividad editado",
                text: "Se ha editado la información del grupo de actividad",
                type: "success",
            });
        },
        async showDeleteConfirmation() {
            this.$bvModal.show('deleteActivityGroup_' + this.item.id)
        },
        async deleteActivityGroup(force) {
            let data = {
                activity_group_id: this.item.id,
                force_delete: force
            }
            this.$store.dispatch('groups/deleteActivityGroup', data)
            .then( response => {
                this.$store.dispatch('groups/loadGroupsBySuprazone', {suprazone_id: this.suprazone.id})
                this.$notify({
                    group: "foo",
                    title: "El grupo de actividad se ha eliminado",
                    text: "El groupo de activida " + this.item.name + " se ha eliminado satisfactoriamente",
                    type: "success",
                });
            })
            .catch( error => {
                this.$notify({
                    group: "foo",
                    title: "El grupo de actividad no se puede eliminar",
                    text: "El grupo de actividad " + this.item.name + " no se puede eliminar ya que tiene objetos vinculados (paradas)",
                    type: "error",
                });
            })
        },
        async copyStops() {
            let data = {
                'activity_group_id': this.item.id,
                'begin_hour': '08:00',
                'name': 'prova2'
                
            }
            await this.$store.dispatch("stops/copyFromActivityGroupId", data)
            data = {
                'suprazone_id': this.suprazone.id,
            }
            await this.$store.dispatch('groups/loadGroupsBySuprazone', data)
            this.$notify({
                    group: "foo",
                    title: "El grupo de actividad se ha duplicado",
                    text: "El grupo de actividad se ha duplicado junto con toda su estructura de paradas",
                    type: "success",
                });

        },
    },
    computed: {
        ...mapGetters(['geopointsListAdmin', 'isDataLoading']),
    }
    
}
</script>